<template>
  <div class="container">
    <unit-title title="原料追溯" />
    <div class="row-list wh-flex-between">
      <div v-for="(item,key) in rawTraceList" :key="key" class="row-item" @click="showRawTrace(item)">
        <div class="wh-flex-between">
          <span>{{ item.materialName }}</span>
          <span>{{ formatTime(item.warehousingTime,'YYYY-MM-DD') }}</span>
        </div>
        <div class="wh-flex-between">
          <span>{{ item.stockType }}</span>
          <span>{{ item.staffName }}</span>
        </div>
      </div>
      <product-info-popup :visible.sync="info.visible" :trace-code="info.traceCode" :trace-temp-data="info.traceData" />
    </div>
  </div>
</template>
<script>
import { firstImgThumb } from '@/filter'
import { formatTime } from '@/utils/convert/convertTime'
import UnitTitle from '@/views/productManage/TraceSource/components/UnitTitle'
import ProductInfoPopup from '@/views/packing/TracePacking/ProductInfoPopup'
export default {
  name: 'ProcessLink',
  filters: {
    firstImgThumb
  },
  components: { ProductInfoPopup, UnitTitle },
  props: {
    rawTrace: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      info: {
        visible: false,
        traceData: {
          farmWorkJSON: [],
          land: {},
          userId: undefined
        },
        traceCode: undefined
      }
    }
  },
  computed: {
    rawTraceList() {
      if (this.rawTrace && this.rawTrace.length) {
        return (this.rawTrace || []).filter(i => {
          return i.flag
        })
      } else {
        return []
      }
    }
  },
  methods: {
    formatTime,
    showRawTrace(item) {
      this.info.visible = true
      this.info.traceData = item
      this.info.traceCode = item.traceCode
    }
  }
}
</script>
<style lang="less" scoped>
  .container {
    width: 100%;
    .row-list{
      width: 100%;
      flex-wrap: wrap;
      .row-item{
        height: 64px;
        font-size: 12px;
        padding: 10px;
        border-radius: 6px;
        background-color: #F5F7FA;
        margin-bottom: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 48%;
        color: #323332;
        >div:first-child{
          >span:first-child{
            font-weight: bold;
          }
          >span:last-child{
            color: #666666;
          }
        }
        >div:last-child{
          color: #666666;
        }
      }
    }
  }
</style>
